import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosError, AxiosResponse } from 'axios'
import { API_URL_FELL } from 'config'
import { SiteType } from 'lib/types'

export const getSitesThunk = createAsyncThunk<
    AxiosResponse<{ user: any, sites: SiteType[] }>,
    string, // args type
    { rejectValue: string } // rejection response value type
>('sites/getSites', async (projectId, { rejectWithValue }) => {
    try {
        const apiResponse = await axios.get(`${API_URL_FELL()}/project/${projectId}/site`)
        return apiResponse
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const deleteSiteThunk = createAsyncThunk<
    { error?: string }, // response type
    { projectId: string; siteId: string }, // args type
    { rejectValue: string } // rejection response value type
>('sites/deleteSite', async (deleteSiteData, { rejectWithValue }) => {
    try {
        await axios.delete(`${API_URL_FELL()}/project/${deleteSiteData.projectId}/site/${deleteSiteData.siteId}`)
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const postSiteThunk = createAsyncThunk<
    SiteType, // response type
    { projectId: string; }, // args type
    { rejectValue: string } // rejection response value type
>('sites/postSite', async (postSiteData, { rejectWithValue }) => {
    try {
        const apiResponse = await axios.post<SiteType>(`${API_URL_FELL()}/project/${postSiteData.projectId}/site`)
        return apiResponse.data
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const updateSiteThunk = createAsyncThunk<
    SiteType, // response type
    { site: SiteType; projectId: string }, // args type
    { rejectValue: string } // rejection response value type
>('sites/updateSite', async ({ site, projectId }, { rejectWithValue }) => {
    try {
        const apiResponse = await axios.put(`${API_URL_FELL()}/project/${projectId}/site/${site.id}`, site)
        return apiResponse.data
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const duplicateSite = createAsyncThunk<
    SiteType,
    { siteId: number; projectId: string },
    { rejectValue: string }
>('sites/duplicate', async ({ siteId, projectId }, { rejectWithValue }) => {
    try {
        const response = await axios.post(`${API_URL_FELL()}/project/${projectId}/site/${siteId}/copy`)
        return response.data
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})
